import { render, staticRenderFns } from "./NewAddPageClassDialog.vue?vue&type=template&id=43f88b0b&scoped=true"
import script from "./NewAddPageClassDialog.vue?vue&type=script&lang=js"
export * from "./NewAddPageClassDialog.vue?vue&type=script&lang=js"
import style0 from "./NewAddPageClassDialog.vue?vue&type=style&index=0&id=43f88b0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f88b0b",
  null
  
)

export default component.exports